<template>
  <div>
    <!-- loading page indicator -->
    <template v-if="isLoadingPage">
      <pre-loader />
    </template>

    <!-- page data -->
    <template v-if="!isLoadingPage">
      <section>
        <div class="section--title">
          <h1>Bill Settlement</h1>
          <hr />
        </div>
      </section>

      <section class="mt-5">
        <FilterTable
          :from-date="queryStrings.from_date"
          :to-date="queryStrings.to_date"
          :searchStr="queryStrings.search_str"
          :enableDownload=true
          v-on:update:fromDate="queryStrings.from_date = $event"
          v-on:update:toDate="queryStrings.to_date = $event"
          v-on:update:searchStr="queryStrings.search_str = $event"
          @flterTable="updateBillSettlements(queryStrings, 'filter')"
          @download="downlodPage()"
        />
      </section>

      <section class="mt-5">
        <div class="row">
          <div class="card border-0">
            <div class="card-body">
              <div class="d-flex border-bottom mb-4 px-2 align-items-center">
                <div class="w-100">
                  <p class="text--secondary font-weight-bold mb-3">
                    Showing result for record date from {{ queryStrings.from_date |  formatDate}} to
                    <span v-if="queryStrings.to_date">
                      {{ queryStrings.to_date |  formatDate}}
                    </span>
                    <span v-else>
                      {{ new Date() |  formatDate}}
                    </span>
                  </p>
                </div>

                <export-actions
                  :table-data="billSettlements"
                  filename="billSettlement.xls"
                  :json-fields="jsonFields"
                  @generatePDF="generatePDF"
                >
                  <button
                    class="ml-2 btn btn-sm btn-light" v-simple-print="'billSettlementTable'"
                  >Print</button>
                </export-actions>
              </div>
              <bill-settlement-table :table-data="billSettlements" />
              <el-pagination
                background
                layout="prev, pager, next"
                :total="paginationData.total"
                :current-page.sync="paginationData.page"
                :page-size.sync="paginationData.limit"
                :hide-on-single-page="true"
                :pager-count="5"
                @current-change="clickCallback"
                @prev-click="prevPage"
                @next-click="nextPage"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <!-- export as pdf -->
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="bill settlement"
          :pdf-quality="2"
          :manual-pagination="false"
          :pdf-content-width="'100%'"
          pdf-format="a4"
          pdf-orientation="landscape"
          ref="html2Pdf"
        >
          <div slot="pdf-content">
            <bill-settlement-table :table-data="billSettlements" />
          </div>
        </vue-html2pdf>
      </section>
    </template>
  </div>
</template>

<script>
import FilterTable from '@/components/shared/FilterTable'
import BillSettlementTable from '@/components/tables/flowTables/BillSettlementTable'
import VueHtml2pdf from 'vue-html2pdf'
export default {
  components: {
    FilterTable,
    BillSettlementTable,
    VueHtml2pdf
  },
  data() {
    return {
      billSettlements: [],
      isLoadingPage: true,
      paginationData: {},
      queryStrings: {
        from_date: (new Date()).toISOString(),
        search_str: '',
        per_page: 50,
        page: 1
      }
    }
  },
  methods: {
    serializeQs(qs) {
      Object.keys(qs).forEach(elem => {
        if(qs[elem]===null || qs[elem]==='') {
          delete qs[elem];
        }
      });
    },
    async getBillSettlements(qs, showLoadingIndicator) {
      if(showLoadingIndicator) {
        this.isLoadingPage = true
      }
      try {
        this.serializeQs(qs);
        const { data } = await this.$repos.billSettlementRepo.getBillSettlements(qs);
         const paginationData = {
          total: data.total,
          currentPage: this.queryStrings.page,
          limit: this.queryStrings.per_page,
          page: this.queryStrings.page
        }
        this.paginationData = {...paginationData}
        this.billSettlements = data.data
      }catch(error) {
        console.log(error)
      }finally {
        this.isLoadingPage = false
      }
    },
    clickCallback(page) {
      this.updateBillSettlements({page})
    },
    prevPage() {
      const page = this.paginationData.page
      this.updateBillSettlements({page: page - 1})
    },
    nextPage() {
      const page = this.paginationData.page
      this.updateBillSettlements({page: page - 1})
    },
    generatePDF () {
      this.$refs.html2Pdf.generatePdf()
    },
    updateBillSettlements(qsObj, type) {
      const qsKey = Object.keys(qsObj)[0]
      const qsValue = Object.values(qsObj)[0]
      this.queryStrings[qsKey] = qsValue
      if(type === 'filter') {
        this.queryStrings.page = 1
      }
      const qs = this.queryStrings
      this.serializeQs(qs)
      this.getBillSettlements (qs, false)
    },
    async downlodPage(){
      /* this.$repos.webPay.downloadWebpayments(
        `/web_pay/reports?start_date=${this.queryStrings.from_date}=&end_date=${this.queryStrings.to_date}`
      ) */
      const link = document.createElement('a');
      const url = 'https://tyson.eirs.gov.ng/tyson/api/settlements/reports?start_date='+this.queryStrings.from_date+'&end_date='+this.queryStrings.to_date
      /* console.log('url', url)
      link.href = url
      link.setAttribute('download', 'report.xlsx'); //or any other extension
      document.body.appendChild(link);
      link.click(); */
      window.open(url, '_blank')
    }
  },
  computed: {
    jsonFields() {
      return {
        "Sent To RDM": "rdm_updated",
        "Payment Lod ID": "payment_log_id",
        "Bill reference": "bill_ref",
        "Bill Id": "bill_id",
        "Transaction Ref No": "transaction_ref_no",
        "Settlement Method ID": 'settlement_method_id',
        "Settlement Date": "settlement_date",
        "Settlement Amount": "settlement_amount",
        "TBPKID": 'tbpkid'
      }
    }
  },
  async mounted() {
    await this.getBillSettlements(this.queryStrings, true)
  },
}
</script>